import { Button, Spacer } from '@sparemin/blockhead';
import React from 'react';
import Modal from 'components/Modal';
import { UpsellModal } from 'state/eventTracking';
import { useModalsActions } from 'state/modal';
import useUpsellModalContentsConfigProps from './useUpsellModalContentsConfig';

interface BaseUpsellModalFooterProps {
  modalName: UpsellModal;
  className?: string;
  children?: React.ReactNode;
  onSuccess?: () => void;
  cta?: string;
}

const BaseUpsellModalFooter: React.FC<BaseUpsellModalFooterProps> = ({
  modalName,
  className,
  children,
  cta = 'upgrade now',
  onSuccess,
}) => {
  const { hideModal } = useModalsActions();

  const { anchorProps } = useUpsellModalContentsConfigProps({
    modalName,
    onSuccess: () => {
      onSuccess?.();
      hideModal();
    },
  });

  return (
    <Modal.Footer className={className}>
      <Spacer orientation="vertical" space={2}>
        <Button as="a" variant="special" fluid {...anchorProps}>
          {cta}
        </Button>

        {children}
      </Spacer>
    </Modal.Footer>
  );
};

export default BaseUpsellModalFooter;
